import { useOrganizationThemeStore } from '../features/org/infrastructure/organization-theme.store';
import { useUserAppearanceStore } from '../features/auth/infrastructure/user-appearance.store';
import type { ColorScheme, OrganizationThemeColors } from './types';

export interface ThemeContextValue {
  colorScheme: ColorScheme;
  setColorScheme: (scheme: ColorScheme) => void;
  toggleColorScheme: () => void;
  organizationColors: OrganizationThemeColors;
  organizationId: string | null;
  clinicName: string;
  logoUrl: string | null;
  isOrganizationThemeLoaded: boolean;
}

export function useTheme(): ThemeContextValue {
  const colorScheme = useUserAppearanceStore((state) => state.colorScheme);
  const setColorScheme = useUserAppearanceStore((state) => state.setColorScheme);
  const toggleColorScheme = useUserAppearanceStore((state) => state.toggleColorScheme);

  const organizationId = useOrganizationThemeStore((state) => state.organizationId);
  const clinicName = useOrganizationThemeStore((state) => state.clinicName);
  const logoUrl = useOrganizationThemeStore((state) => state.logoUrl);
  const organizationColors = useOrganizationThemeStore((state) => state.colors);
  const isOrganizationThemeLoaded = useOrganizationThemeStore((state) => state.isLoaded);

  return {
    colorScheme,
    setColorScheme,
    toggleColorScheme,
    organizationColors,
    organizationId,
    clinicName,
    logoUrl,
    isOrganizationThemeLoaded,
  };
}
